import React, { useEffect } from "react";
import "./css/Login.css";
import AccessDeniedImage from "../../assets/images/accessDenied.png";
import SffLanguage from "../../components/common/Languages/SffLanguage";
const AccessDeniedPage = () => {
  const { t } = SffLanguage();
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <div className="adDiv">
      <img src={AccessDeniedImage} alt="accessdenied" className="adImage" />
      <h2 className="heading">{t("We are Sorry...")}</h2>
      <p className="message">
        {t("You do not have permission to access this page")}
      </p>
      <p className="message">
        {t("Please contact your Local Administrator to request access")}
      </p>
    </div>
  );
};
export default AccessDeniedPage;
